//Quantidade de clientes na fila
export const queuesColors = [
    {
        colorClass: "alert-secondary",
        quantity: -5
    },
    {
        colorClass: "alert-success",
        quantity: 1,
    },
    {
        colorClass: "alert-warning",
        quantity: 5
    },
    {
        colorClass: "alert-danger",
        quantity: 10
    }
]
